// ============================================================================
// JAMB Learn Content — Physics
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_PHYSICS_LEARN_SS1 } from '../../waec/learn/ss1/physics';
import { WAEC_PHYSICS_LEARN_SS2 } from '../../waec/learn/ss2/physics';
import { WAEC_PHYSICS_LEARN_SS3 } from '../../waec/learn/ss3/physics';

export const JAMB_LEARN_PHYSICS = [
  ...WAEC_PHYSICS_LEARN_SS1,
  ...WAEC_PHYSICS_LEARN_SS2,
  ...WAEC_PHYSICS_LEARN_SS3,
];
